import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchCurrentUser } from "../../slices/users";
import { Spinner, Center, Text } from "@chakra-ui/react";
import {logout} from "../../slices/authSlice";
import {logout as logoutUser} from "../../slices/users";
import { clearLocalCartData } from "../../slices/cart";
import { openLoginModal } from "../../slices/authSlice";
import ButtonC from "../../theme/ButtonC";

export default function Profile({setIsProfileOpen}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { user, status, error } = useSelector((state) => state.user);
  const {userLoggedIn} = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(fetchCurrentUser());
  }, [dispatch]);

  const handleLogout = (e) => {
    e.preventDefault();
    dispatch(logout());
    dispatch(logoutUser());
    dispatch(clearLocalCartData())
    setIsProfileOpen(false);
          window.location.reload();
    navigate("/");


  };

  if (status === "loading") {
    return (
      <Center py={10}>
        <Spinner size="xl" />
      </Center>
    );
  }

  if (status === "failed") {
    return (
     <></>
    );
  }

  if (!user) {
    return (
      <Center py={10}>
        <Text color="gray.600">No user data found.</Text>
      </Center>
    );
  }

  return (
    <>
      <h6>{user.first_name || ""}</h6>

      <div className="wptb-icon-box1 style2">
        <div className="wptb-item--inner flex-start">
          <div className="wptb-item--icon">
            <i className="bi bi-envelope"></i>
          </div>
          <div className="wptb-item--holder">
            <p className="wptb-item--description">
              <a href={`mailto:${user.email}`}>{user.email}</a>
            </p>
          </div>
        </div>
      </div>

      <div className="wptb-icon-box1 style2">
        <div className="wptb-item--inner flex-start">
          <div className="wptb-item--icon">
            <i className="bi bi-telephone"></i>
          </div>
          <div className="wptb-item--holder">
            <p className="wptb-item--description">
              <a href={`tel:${user.phone}`}>+91 {user.phone}</a>
            </p>
          </div>
        </div>
      </div>

      {user.addresses?.length > 0 && (
        <div className="wptb-icon-box1 style2">
          <div className="wptb-item--inner flex-start">
            <div className="wptb-item--icon">
              <i className="bi bi-geo-alt"></i>
            </div>
            <div className="wptb-item--holder">
              <p className="wptb-item--description">
                {user.addresses[0]?.line1}, {user.addresses[0]?.city},{" "}
                {user.addresses[0]?.state}, {user.addresses[0]?.pincode}
              </p>
            </div>
          </div>
        </div>
      )}

  <div className="mt-4" style={{
    marginLeft : -20
  }}>
    <div 
        className="flex justify-start gap-4" 
        style={{
            display: 'flex',
            marginBottom: '20px', 
        }}
    >
        <div>
            <ButtonC
                label="Profile" 
                onClick={() => {navigate("/account?tab=Profile")

                  setIsProfileOpen(false);
                }}
                bg="var(--cr-red-logo)"
            />
        </div>

     
        <div>
            <ButtonC
                label="My Orders" 
                onClick={() => {navigate("/account?tab=My Orders")

                  setIsProfileOpen(false);
                }}
                bg="var(--cr-red-logo)"
            />
        </div>
        
        <div>
            <ButtonC
                label="Addresses" 
                onClick={() => {navigate("/account?tab=Addresses")

                  setIsProfileOpen(false);
                }}
                bg="var(--cr-red-logo)"
            />
        </div>
    </div>

    {userLoggedIn && (
        <div className="flex justify-center w-full"> 
            <div>
                <ButtonC
                    label="Log Out" 
                    onClick={handleLogout}
                    bg="var(--cr-red-logo)"
                />
            </div>
        </div>
    )}
</div>
    </>
  );
}
